import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Text from "../../utils/commonComponent/Custom/text";
import CommonForm from "../../utils/commonComponent/commonForm";
import {
  CancelButton,
  SaveAndUpdate,
} from "../../utils/commonComponent/Custom/Button";
import {
  fetchByTable,
  fetchQuery,
} from "./../../utils/commonComponent/fetched";
import axiosWithToken from "../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL } from "../../global";
import { getPermissions } from "../rbac/hasAccess";
import { validateRequiredFields } from "../../utils/commonComponent/errorAlert";
import { calculateAvailableBalance, weekOffs } from "../leave/applyLeave";

const EditleaveRegularization = (props) => {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const navigate = useNavigate();
  const [inputStates, setInputStates] = React.useState({});
  const [employeeData, setEmployeeData] = React.useState({});
  const [leaveManagementDetails, setLeaveManagementDetails] = React.useState(
    [],
  );
  const [selectedLeaveTypeId, setSelectedLeaveTypeId] = React.useState(() => {
    const storedValue = localStorage.getItem("selectedLeaveTypeId");
    return storedValue ? Number(storedValue) : 1;
  });
  const [leaveData, setLeaveData] = React.useState({
    availableBalance: 0,
    applyingDays: 0,
  });
  const _employeeId = Number(localStorage.getItem("employeeId"));
  const _userType = Number(localStorage.getItem("type"));

  const inputFields = [
    // { type: "TextField", label: "Document No", stateKey: "documentNo" },

    {
      type: "Autocomplete",
      label: "Employee Name",
      stateKey: "employeesId",
      options: "employees",
      valueKey: "id",
      getOptionLabelKey: "name",
      // optionsFilter: `${
      //   _employeeId ? `where id=${_employeeId} and status = 1` : ""
      // }`,
    },
    {
      type: "Autocomplete",
      label: "Leave Type",
      stateKey: "leaveType",
      options: [
        { id: 1, name: "Sick Leave" },
        { id: 2, name: "Casual Leave" },
        { id: 3, name: "Privileged Leave" },

        ...(employeeData?.gender === "Male"
          ? [{ id: 5, name: "Paternity Leave" }]
          : employeeData?.gender === "Female"
            ? [
                { id: 4, name: "Maternity Leave" },
                { id: 6, name: "Menstrual Leave" },
              ]
            : []),
      ],
      valueKey: "name",
      getOptionLabelKey: "name",
    },
    {
      type: "TextField",
      label: "Available Balance",
      stateKey: "leaveBalance", //availableBalance
      disabled: true,
    },
    {
      type: "DatePicker",
      label: "From Date",
      stateKey: "fromDate",
      // disablePastDates: true,
    },
    {
      type: "Autocomplete",
      label: "Leave Value",
      stateKey: "fromLeaveValue",
      options: [
        { id: 1, name: "Full Day" },
        { id: 2, name: "First Half Day" },
        { id: 3, name: "Second Half Day" },
      ],
      valueKey: "name",
      getOptionLabelKey: "name",
    },
    {
      type: "DatePicker",
      label: "Till Date",
      stateKey: "toDate",
      disablePastDates: true,
      minimumDate: inputStates?.fromDate,
    },
    {
      type: "Autocomplete",
      label: "Leave Value",
      stateKey: "toLeaveValue",
      options: [
        { id: 1, name: "Full Day" },
        { id: 2, name: "First Half Day" },
        { id: 3, name: "Second Half Day" },
      ],
      valueKey: "name",
      getOptionLabelKey: "name",
    },
  ];

  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };

  const fetchleaveRegularizationDetails = async () => {
    try {
      const [leaveRegularization] = await fetchQuery(
        `SELECT * FROM leaveRegularization WHERE id = ${params.id}`,
      );
      setInputStates(leaveRegularization);
    } catch (error) {
      console.error("Error fetching Holiday data:", error);
    }
  };

  const onSubmit = async () => {
    const fieldsToValidate = [
      { value: inputStates.leaveType, label: "Leave Type is required" },
      { value: inputStates.fromDate, label: "From Date is required" },
      {
        value: inputStates.fromLeaveValue,
        label: "From Leave Value is required",
      },
      { value: inputStates.toDate, label: "Till Date is required" },
      {
        value: inputStates.toLeaveValue,
        label: "Till Leave Value is required",
      },
      { value: inputStates.employeesId, label: "Employee Name is required" },
    ];

    if (!validateRequiredFields(fieldsToValidate)) return;

    const { leaveBalance, ...payload } = inputStates;

    try {
      const baseUrl = BASE_URL;

      /** STEP 1: Prepare leaveManagement payload */
      const leaveManagementPayload = {
        ...payload,
        employeeId: payload.employeesId,
        applyLeaveDate: new Date(),
      };
      delete leaveManagementPayload.employeesId;

      /** STEP 2: POST or PATCH leaveManagement */
      let leaveManagementId;

      if (params.id == "0") {
        // CREATE
        const leaveManagementRes = await axiosWithToken.post(
          baseUrl + "leaveManagement",
          leaveManagementPayload,
        );

        leaveManagementId = leaveManagementRes?.data?.insertId;
      } else {
        // UPDATE
        await axiosWithToken.patch(
          `${baseUrl}leaveManagement/${inputStates?.leaveManagementId}`,
          leaveManagementPayload,
        );

        leaveManagementId = inputStates?.leaveManagementId;
      }

      /** STEP 3: leaveRegularization payload */
      const leaveRegularizationPayload = {
        ...payload,
        leaveManagementId,
      };

      /** STEP 4: POST or PATCH leaveRegularization */
      const url = baseUrl + "leaveRegularization";

      if (params.id !== "0") {
        await axiosWithToken.patch(
          `${url}/${params.id}`,
          leaveRegularizationPayload,
        );
      } else {
        await axiosWithToken.post(url, leaveRegularizationPayload);
      }

      toast.success(
        params.id !== "0"
          ? "Leave Updated Successfully!"
          : "Leave Created Successfully!",
      );

      if (params.id == 0) {
        setTimeout(() => navigate("/leave/leaveRegularization"), 1000);
      } else {
        setTimeout(() => window.location.reload(), 1000);
      }
    } catch (error) {
      console.error("Submission failed:", error);
    }
  };

  const getDaysBetween = (
    fromDate,
    toDate,
    MS_IN_DAY,
    fromLeaveValue = "",
    toLeaveValue = "",
  ) => {
    if (!fromDate || !toDate) return 0;

    const start = new Date(fromDate);
    const end = new Date(toDate);

    if (isNaN(start) || isNaN(end)) return 0;

    // Calculate normal day difference
    let applyingDays = Math.abs(Math.floor((end - start) / MS_IN_DAY)) + 1;

    // ----- Half Day Logic -----
    if (start.toDateString() === end.toDateString()) {
      // Single day leave
      if (
        fromLeaveValue === "First Half Day" ||
        fromLeaveValue === "Second Half Day"
      ) {
        applyingDays = 0.5;
      }
    } else {
      // Multi-day leave

      if (
        fromLeaveValue === "First Half Day" ||
        fromLeaveValue === "Second Half Day"
      ) {
        applyingDays -= 0.5;
      }

      if (
        toLeaveValue === "First Half Day" ||
        toLeaveValue === "Second Half Day"
      ) {
        applyingDays -= 0.5;
      }
    }

    return applyingDays;
  };

  const fetchLeaveManagementDetails = async () => {
    const whereConditions =
      selectedLeaveTypeId === 1
        ? `WHERE lm.employeeId=${inputStates.employeesId} AND lm.status=1`
        : `WHERE lm.status = 1 AND (
          (eod.appprovalManagerId = ${inputStates.employeesId} AND lm.approveManagerStatus != 1 AND lm.approveManagerStatus != 2)
          OR
          (eod.approvalLevel1Id = ${inputStates.employeesId} AND lm.approveManagerStatus != 0 AND lm.approveManagerStatus != 3 AND lm.approveLevel1 != 1 AND lm.approveLevel1 != 2)
          OR
          (eod.approvalLevel2Id = ${inputStates.employeesId} AND lm.approveLevel1 != 0 AND lm.approveLevel1 != 3 AND lm.approveLevel2 != 1 AND lm.approveLevel2 != 2)
        ) AND lm.status=1`;

    try {
      const leaveManagement = await fetchQuery(
        `SELECT lm.id,lm.documentNo,lm.applyLeaveDate,lm.leaveType,lm.leaveBalance,lm.fromDate,lm.toDate,lm.fromLeaveValue,lm.toLeaveValue,lm.remark,lm.docUrl,lm.employeeId,lm.approveManagerStatus,lm.reasonStatus,lm.rejectRemark,lm.approveLevel1,lm.approveLevel2,e.employeesCode AS employeesCode,e.name AS employeeName,eod.appprovalManagerId,CONCAT(em1.name,' (',em1.employeesCode,')') AS approvalManagerEmployee,eod.approvalLevel1Id,CONCAT(em2.name,' (',em2.employeesCode,')') AS approvalLevel1Employee,eod.approvalLevel2Id,CONCAT(em3.name,' (',em3.employeesCode,')') AS approvalLevel2Employee FROM leaveManagement lm LEFT JOIN employees e ON lm.employeeId=e.id LEFT JOIN employeeOtherData eod ON lm.employeeId=eod.employeeId LEFT JOIN employees em1 ON eod.appprovalManagerId=em1.id LEFT JOIN employees em2 ON eod.approvalLevel1Id=em2.id LEFT JOIN employees em3 ON eod.approvalLevel2Id=em3.id ${whereConditions} ORDER BY lm.id DESC`,
      );

      const MS_IN_DAY = 1000 * 60 * 60 * 24;
      const statusMap = {
        0: "Pending",
        1: "Pending",
        2: "Approved",
        3: "Rejected",
      };

      const updatedLeaveManagement = leaveManagement.map((item) => {
        const statuses = [
          item.approveManagerStatus,
          item.approveLevel1,
          item.approveLevel2,
        ].map(Number);
        // const leaveStatus = statuses.includes(3)
        //   ? statusMap[3]
        //   : statuses.reverse().includes(2)
        //   ? statusMap[2]
        //   : statusMap[0];

        const leaveStatus = statuses.includes(3)
          ? statusMap[3]
          : statusMap[item.approveLevel2] || item.approveLevel2;

        return {
          ...item,
          days: getDaysBetween(
            item.fromDate,
            item.toDate,
            MS_IN_DAY,
            item.fromLeaveValue,
            item.toLeaveValue,
          ),
          approveManagerStatus:
            statusMap[item.approveManagerStatus] || item.approveManagerStatus,
          approveLevel1: statusMap[item.approveLevel1] || item.approveLevel1,
          approveLevel2: statusMap[item.approveLevel2] || item.approveLevel2,
          leaveStatus,
        };
      });

      setLeaveManagementDetails(updatedLeaveManagement);
    } catch (error) {
      console.error("Error fetching leave management:", error);
    }
  };

  useEffect(() => {
    if (!inputStates.employeesId) return;

    const fetchEmployeeOtherData = async () => {
      try {
        const [employeeOtherData] = await fetchQuery(
          `select * from employees where id = ${inputStates.employeesId} AND status=1`,
        );
        setEmployeeData(employeeOtherData);
      } catch (error) {
        console.error("Error fetching employee data:", error);
      }
    };

    fetchEmployeeOtherData();
  }, [inputStates.employeesId]);

  useEffect(() => {
    if (!inputStates?.leaveType) {
      return;
    }

    const calculateBalance = async () => {
      try {
        const { availableBalance, applyingDays } =
          await calculateAvailableBalance(
            inputStates.leaveType,
            leaveManagementDetails,
            weekOffs,
            inputStates.fromDate,
            inputStates.toDate,
            inputStates.employeesId,
            inputStates.fromLeaveValue,
            inputStates.toLeaveValue,
          );

        // Store both values in single state
        setLeaveData({
          availableBalance,
          applyingDays,
        });

        if (
          (availableBalance <= 0 && inputStates.leaveType !== "Casual Leave") ||
          availableBalance < applyingDays
        ) {
          toast.warning(
            `You cannot apply leave. ${inputStates.leaveType} is not available. You are applying Days are ${applyingDays}`,
            { autoClose: 5000 },
          );
        }

        updateInputObject("leaveBalance", availableBalance);
      } catch (err) {
        console.error("Error calculating leave balance", err);
      }
    };

    calculateBalance();
  }, [
    inputStates.leaveType,
    inputStates.fromDate,
    inputStates.toDate,
    inputStates.fromLeaveValue,
    inputStates.toLeaveValue,
    leaveManagementDetails,
    weekOffs,
    inputStates.employeesId,
  ]);

  useEffect(() => {
    if (params.id != 0) fetchleaveRegularizationDetails();
  }, [params]);

  useEffect(() => {
    if (inputStates.employeesId) fetchLeaveManagementDetails();
  }, [inputStates.employeesId]);

  return (
    <div>
      <Text variant="h3" bold className="text-blue-600">
        {params.id == 0 ? "Create New Leave" : `Update Leave`}
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={inputFields}
      />
      <br />
      <div className="flex gap-10 mt-5 justify-end ">
        <CancelButton
          id="btn-cancel"
          label="Cancel"
          outline
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        />
        {(permissions.save || permissions.allAccess) && (
          <SaveAndUpdate
            id="btn-add-outline"
            label={params.id == 0 ? "Save" : "Update"}
            disabled={
              ![1, 8].includes(_userType) &&
              inputStates.leaveType !== "Casual Leave" &&
              (!inputStates?.leaveBalance ||
                inputStates.leaveBalance === 0 ||
                leaveData.availableBalance < leaveData.applyingDays)
            }
            onClick={onSubmit}
          />
        )}
      </div>
    </div>
  );
};

export default EditleaveRegularization;
